class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.getNavbarItems = this.querySelectorAll('.tabs-navbar-item');
    this.getTubs = this.querySelectorAll('.tabs-content-item');

    this.getNavbarItems.forEach((item, index) => {

      item.addEventListener('click', () => {
        this.getNavbarItems.forEach(item => item.setAttribute('data-show', 'false'));
        this.getTubs.forEach(tub => tub.setAttribute('data-show', 'false'));
        item.setAttribute('data-show', 'true');
        this.getTubs[index].setAttribute('data-show', 'true');
      });
    });
  }
}

customElements.define('tabs-section', TabsSection);